import {
  Trophy,
  Search,
  BookOpen,
  BookMarked,
  Zap,
  TrendingUp,
  Clock,
  Target,
  ArrowLeftRight,
  Repeat2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../styles/selectGameMode.css";
import PageHeader from "../components/PageHeader";

export default function SelectGameModes() {
  const navigate = useNavigate();

  const gameModes = [
    {
      id: "Vocab Practice",
      title: "Vocabulary",
      description:
        "Match words to their meanings and level up your vocabulary one round at a time",
      icon: <TrendingUp className="w-8 h-8" />,
      difficulty: "Scaling",
      estimatedTime: "1-5 min",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-teal-200",
      status: "Test your vocab limits",
      rewards: "Reach vocab tiers to unlock owls",
      link: "/vocabMatchingGame",
    },
    {
      id: "synonyms",
      title: "Synonyms",
      description:
        "Find the perfect match — train your brain to connect words that mean the same thing",
      icon: <Repeat2 className="w-8 h-8" />,
      difficulty: "Scaling",
      estimatedTime: "1-5 min",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-200",
      status: "Test your word knowledge",
      rewards: "Earn coins and ELO",
      link: "/synonymsGame",
    },
    {
      id: "antonyms",
      title: "Antonyms",
      description:
        "Think in opposites — master contrasts and make your vocabulary twice as powerful",
      icon: <ArrowLeftRight className="w-8 h-8" />,
      difficulty: "Scaling",
      estimatedTime: "1-5 min",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      borderColor: "border-orange-200",
      status: "Test your word knowledge",
      rewards: "Earn coins and ELO",
      link: "/antonymsGame",
    },
    {
      id: "spot-word",
      title: "Spot the Word",
      description: "Scan the passage, hunt the word — how fast can you spot it?",
      icon: <Search className="w-8 h-8" />,
      difficulty: "Easy-Medium",
      estimatedTime: "3-7 min",
      color: "from-green-500 to-green-700",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
      status: "Quick Play",
      rewards: "+Quick XP, Accuracy Bonus",
      link: "/levelSelector",
      levelSelectorTitle: "Spot the Word",
      gameLink: "/spotWordGame",
    },
    {
      id: "comprehension",
      title: "Comprehension",
      description: "Read, think, and pick the right answer — your comprehension skills will grow every round",
      icon: <BookOpen className="w-8 h-8" />,
      difficulty: "Adaptive",
      estimatedTime: "8-12 min",
      color: "from-indigo-500 to-indigo-700",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-200",
      status: "Level Adaptive",
      rewards: "+Base XP, Comprehension Points",
      link: "/levelSelector",
      levelSelectorTitle: "Comprehension Practice",
      gameLink: "/comprehensionGame",
    },
    {
      id: "book-comprehension",
      title: "Book Comprehension",
      description:
        "Go deeper — choose a real book chapter and prove you understood every detail",
      icon: <BookOpen className="w-8 h-8" />,
      difficulty: "Adaptive",
      estimatedTime: "30-45 min",
      color: "from-indigo-500 to-indigo-700",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-200",
      status: "Real Books",
      rewards: "+Deep XP, Literature Owls",
      link: "/bookSelector",
    },
    {
      id: "book-reading",
      title: "Book Reading",
      description:
        "Explore real books at your own pace — tap any word for its meaning and get AI-powered explanations",
      icon: <BookMarked className="w-8 h-8" />,
      difficulty: "Self-Paced",
      estimatedTime: "10-30 min",
      color: "from-indigo-500 to-indigo-700",
      // color: "from-amber-500 to-orange-500",
      bgColor: "bg-amber-50",
      borderColor: "border-amber-200",
      status: "4 Books Available",
      rewards: "+Reading XP, Story Owls",
      link: "/bookReading",
    },
    {
      id: "MCQ-master",
      title: "MCQ Master",
      description: "The clock is ticking — read fast, think faster, and rack up your score",
      icon: <Zap className="w-8 h-8" />,
      difficulty: "Multiple choice",
      estimatedTime: "2-5 min",
      color: "from-red-500 to-red-700",
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
      status: "Rush Mode",
      rewards: "+Speed Bonus, Time Master Owls",
      link: "/levelSelector",
      levelSelectorTitle: "MCQ Master",
      gameLink: "/mcq10Game",
    },
    {
      id: "ranked",
      title: "Ranked Games",
      description: "Put your skills on the line — battle other players and fight your way up the leaderboard",
      icon: <Trophy className="w-8 h-8" />,
      difficulty: "Competitive",
      estimatedTime: "10-15 min",
      color: "from-yellow-500 to-orange-600",
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-200",
      status: "Season 2 Active",
      rewards: "+ELO Rating, Seasonal Rewards",
      link: "/rankedGame",
    },
    // {
    //   id: "extreme",
    //   title: "Extreme Mode",
    //   description: "Ultimate challenge with complex texts and questions",
    //   icon: <Flame className="w-8 h-8" />,
    //   difficulty: "Extreme",
    //   estimatedTime: "15-25 min",
    //   color: "from-orange-600 to-red-600",
    //   bgColor: "bg-orange-50",
    //   borderColor: "border-orange-200",
    //   status: "Masters Only",
    //   rewards: "+Extreme XP, Legendary Owls",
    //   link: "/extremeGame",
    // },
    // {
    //   id: 'ascension',
    //   title: 'Ascension Mode',
    //   description: 'Start easy, questions get progressively harder',
    //   icon: <TrendingUp className="w-8 h-8" />,
    //   difficulty: 'Scaling',
    //   estimatedTime: '10-20 min',
    //   color: 'from-pink-500 to-purple-600',
    //   bgColor: 'bg-pink-50',
    //   borderColor: 'border-pink-200',
    //   status: 'Endless Challenge',
    //   rewards: '+Scaling XP, Ascension Ranks',
    //   link: "/home"
    // },
    // {
    //   id: 'campaign',
    //   title: 'Campaign',
    //   description: 'Progress through story adventures with themed passages',
    //   icon: <Book className="w-8 h-8" />,
    //   difficulty: 'Progressive',
    //   estimatedTime: '15-30 min',
    //   color: 'from-purple-500 to-purple-700',
    //   bgColor: 'bg-purple-50',
    //   borderColor: 'border-purple-200',
    //   status: 'Chapter 3 Available',
    //   rewards: '+50-100 XP, Story Owls',
    //   link: "/home"
    // },
    // {
    //   id: 'daily',
    //   title: 'Daily Challenge',
    //   description: "Complete today's special comprehension task",
    //   icon: <Calendar className="w-8 h-8" />,
    //   difficulty: 'Medium',
    //   estimatedTime: '5-10 min',
    //   color: 'from-blue-500 to-blue-700',
    //   bgColor: 'bg-blue-50',
    //   borderColor: 'border-blue-200',
    //   status: 'Available Today',
    //   rewards: '+Daily Bonus, Streak Multiplier',
    //   urgent: true,
    //   link: "/projLoginPage"
    // },
    // {
    //   id: 'long-texts',
    //   title: 'Long Texts',
    //   description: 'Extended passages for advanced comprehension training',
    //   icon: <FileText className="w-8 h-8" />,
    //   difficulty: 'Hard',
    //   estimatedTime: '20-35 min',
    //   color: 'from-gray-600 to-gray-800',
    //   bgColor: 'bg-gray-50',
    //   borderColor: 'border-gray-200',
    //   status: 'Advanced Level',
    //   rewards: '+Major XP, Endurance Rewards',
    //   link: "/home"
    // },
  ];

  return (
    <div className="select-game-modes">
      <PageHeader
        pageTitle="Select your Game Mode to start playing and learning!"
        pageSubtitle="Choose your reading challenge"
      />

      {/* Game Modes Grid */}
      <div className="game-modes-container">
        <div className="game-modes-grid">
          {gameModes.map((mode) => (
            <div
              key={mode.id}
              className={`game-mode-card ${mode.urgent ? "urgent" : ""}`}
            >
              {mode.urgent && <div className="urgent-badge">NEW</div>}
              <div
                className={`mode-icon ${
                  mode.color.replace("from-", "bg-").split(" ")[0]
                }`}
              >
                {mode.icon}
              </div>
              <div className="mode-content">
                <h3 className="mode-title">{mode.title}</h3>
                <p className="mode-description">{mode.description}</p>
                <div className="mode-details">
                  <div className="detail-item">
                    <Target className="w-4 h-4" />
                    <span>{mode.difficulty}</span>
                  </div>
                  <div className="detail-item">
                    <Clock className="w-4 h-4" />
                    <span>{mode.estimatedTime}</span>
                  </div>
                </div>
                <div className="mode-status">
                  <span className="status-text">{mode.status}</span>
                </div>
                <div className="mode-rewards">
                  <span className="rewards-text">{mode.rewards}</span>
                </div>
              </div>
              <div className="play-button">
                <button
                  className="play-btn"
                  onClick={() =>
                    navigate(mode.link, {
                      state: mode.levelSelectorTitle
                        ? {
                            link: mode.gameLink,
                            title: mode.levelSelectorTitle,
                          }
                        : { fromGameSelect: true },
                    })
                  }
                >
                  Play →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Stats */}
      <div className="quick-stats">
        <div className="quick-stats-container">
          <div className="quick-stat">
            <span className="quick-stat-label">Games Today</span>
            <span className="quick-stat-value">3</span>
          </div>
          <div className="quick-stat">
            <span className="quick-stat-label">Win Rate</span>
            <span className="quick-stat-value">87%</span>
          </div>
          <div className="quick-stat">
            <span className="quick-stat-label">Best Streak</span>
            <span className="quick-stat-value">12</span>
          </div>
          <div className="quick-stat">
            <span className="quick-stat-label">Favorite Mode</span>
            <span className="quick-stat-value">Campaign</span>
          </div>
        </div>
      </div>
    </div>
  );
}
